import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary text-secondary-foreground mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-heading font-bold">Elite Plumbers</h3>
            <p className="text-sm text-secondary-foreground/80 leading-relaxed">
              Professional, reliable, and high-quality plumbing services for homes and businesses across London. 
              Trusted partners with London Boroughs for over 10 years.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-secondary-foreground/80 hover:text-primary transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/coverage-areas" className="text-sm text-secondary-foreground/80 hover:text-primary transition-colors duration-300">
                  Coverage Areas
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-sm text-secondary-foreground/80 hover:text-primary transition-colors duration-300">
                  Feedbacks
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-secondary-foreground/80 hover:text-primary transition-colors duration-300">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li className="text-sm text-secondary-foreground/80">Professional Plumbing</li>
              <li className="text-sm text-secondary-foreground/80">Leak Detection & Repairs</li>
              <li className="text-sm text-secondary-foreground/80">Bathroom & Kitchen Installations</li>
              <li className="text-sm text-secondary-foreground/80">Boiler & Heating Services</li>
              <li className="text-sm text-secondary-foreground/80">Pipework & Water Pressure</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm text-secondary-foreground/80">
                <Phone className="w-4 h-4 mt-0.5 text-primary" />
                <a href="tel:07356255155" className="hover:text-primary transition-colors duration-300">
                  07356 255155
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-secondary-foreground/80">
                <Mail className="w-4 h-4 mt-0.5 text-primary" />
                <a href="mailto:eliteplumbersltd@gmail.com" className="hover:text-primary transition-colors duration-300">
                  eliteplumbersltd@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-secondary-foreground/80">
                <MapPin className="w-4 h-4 mt-0.5 text-primary" />
                <span>London, United Kingdom</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-secondary-foreground/80">
                <Clock className="w-4 h-4 mt-0.5 text-primary" />
                <span>Mon-Fri: 8am-5pm</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-secondary-foreground/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-secondary-foreground/60">
              © {currentYear} Elite Plumbers. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/" className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link to="/" className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-300">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;